import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import { Icon } from 'leaflet';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

export type LatLon = { lat: number; lon: number };

// Leaflet's default marker icons reference assets via a path that breaks under
// Vite bundling, so build the Icon from the imported PNG asset URLs instead.
const pinIcon = new Icon({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

const AUCKLAND: LatLon = { lat: -36.8517, lon: 174.84 };

function ClickToSet({ onSet }: { onSet: (v: LatLon) => void }) {
  useMapEvents({
    click(e) {
      onSet({ lat: e.latlng.lat, lon: e.latlng.lng });
    },
  });
  return null;
}

export function WeatherLocationControl({
  value,
  onChange,
}: {
  value: LatLon | null;
  onChange: (next: LatLon | null) => void;
}) {
  const center = value ?? AUCKLAND;

  const setNum = (key: 'lat' | 'lon', raw: string) => {
    const n = parseFloat(raw);
    if (!Number.isFinite(n)) return;
    onChange({ ...(value ?? AUCKLAND), [key]: n });
  };

  const field = { width: '7rem' } as const;

  return (
    <div>
      <div style={{ height: 220, marginBottom: 'var(--sp-2)' }}>
        <MapContainer
          center={[center.lat, center.lon]}
          zoom={12}
          style={{ height: '100%', width: '100%' }}
        >
          <TileLayer
            attribution="&copy; OpenStreetMap contributors"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <ClickToSet onSet={onChange} />
          {value && (
            <Marker
              position={[value.lat, value.lon]}
              icon={pinIcon}
              draggable
              eventHandlers={{
                dragend(e) {
                  const ll = (
                    e.target as { getLatLng: () => { lat: number; lng: number } }
                  ).getLatLng();
                  onChange({ lat: ll.lat, lon: ll.lng });
                },
              }}
            />
          )}
        </MapContainer>
      </div>
      <div style={{ display: 'flex', gap: 'var(--sp-2)', alignItems: 'center' }}>
        <label>
          lat{' '}
          <input
            aria-label="latitude"
            type="number"
            step="0.0001"
            value={value?.lat ?? ''}
            onChange={(e) => setNum('lat', e.target.value)}
            style={field}
          />
        </label>
        <label>
          lon{' '}
          <input
            aria-label="longitude"
            type="number"
            step="0.0001"
            value={value?.lon ?? ''}
            onChange={(e) => setNum('lon', e.target.value)}
            style={field}
          />
        </label>
        <button type="button" onClick={() => onChange(null)} disabled={!value}>
          Clear
        </button>
      </div>
    </div>
  );
}
